import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/common-main-article/common-main-article.ts
var CommonMainArticle = class extends SnippetElement {
  connectedCallback() {
    const mobileMedia = window.matchMedia("(min-width: 768px)");
    Array.from(document.querySelectorAll("article img")).forEach(
      (elm) => {
        elm.setAttribute("data-modal-blog", "");
        if (mobileMedia.matches) {
          elm.classList.add("cursor-pointer");
        }
        elm.addEventListener("click", () => {
          var _a, _b, _c, _d;
          if (mobileMedia.matches) {
            (_c = (_a = this.blogModal) == null ? void 0 : _a.querySelector("img")) == null ? void 0 : _c.setAttribute("src", (_b = elm.getAttribute("src")) != null ? _b : "");
            (_d = this.blogModal) == null ? void 0 : _d.toggle();
          }
        });
      }
    );
    this.calculateReadingTime(this.readingTime.getAttribute("data-article-reading-time"));
  }
  calculateReadingTime(characterCount) {
    const charactersPerMinute = 1e3;
    const readingTime = Math.ceil(characterCount / charactersPerMinute);
    this.readingTime.innerHTML = readingTime.toString() + " Min.";
  }
};
__decorateClass([
  query("[data-article-reading-time]")
], CommonMainArticle.prototype, "readingTime", 2);
__decorateClass([
  query("[blog-modal]")
], CommonMainArticle.prototype, "blogModal", 2);
CommonMainArticle = __decorateClass([
  defineElement("common-main-article")
], CommonMainArticle);
export {
  CommonMainArticle
};
